import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Check } from "@mui/icons-material";
import { FamilyService } from "src/FamilyGroup/services/family";
import OtpInputMui from "./OtpInputMui";
import { showModalConfirmFamilyGroupState, tutRutConfirmState } from "../atom";
import { useRecoilState } from "recoil";
import useFamilyGroupLoader from "../hooks/useFamilyGroupLoader";

export const ModalConfirmFamilyGroup = () => {
  const [showModalConfirmFamilyGroup, setShowModalConfirmFamilyGroup] =
    useRecoilState(showModalConfirmFamilyGroupState);
  const [tutRutConfirm, setTutRutConfirm] = useRecoilState(tutRutConfirmState);
  const [message, setMessage] = useState({ error: false, text: "" });
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  const { loadFamilyGroup, payloadToken } = useFamilyGroupLoader();

  const handleConfirm = async () => {
    setLoading(true);
    const body = {
      tutRut: tutRutConfirm,
      rutPaciente: payloadToken.Username,
      tutCodConfirm: code,
    };

    const response = await FamilyService.confirmFamilyMember(body);
    if (response.data.estado === 0) {
      setMessage({ error: true, text: response.data.descripcion });
      setLoading(false);
      return;
    }
    setShowModalConfirmFamilyGroup(false);
    setLoading(false);
    await loadFamilyGroup();
    handleClose();
  };

  const handleClose = () => {
    setShowModalConfirmFamilyGroup(false);
    setMessage({ error: false, text: "" });
    setTutRutConfirm("");
    setCode("");
  };

  return (
    <Dialog
      open={showModalConfirmFamilyGroup}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Confirmar Grupo Familiar</DialogTitle>
      <DialogContent>
        <Stack spacing={2} px={4} py={2}>
          <Typography variant="caption" fontWeight={600}>
            Se envió un correo con el código de verificación. Ingresa el código
            para confirmar la invitación al grupo familiar.
          </Typography>
          <OtpInputMui length={6} onChange={(code) => setCode(code)} />
          {message.text && (
            <Alert
              severity={message.error ? "error" : "success"}
              onClose={() => setMessage({ ...message, text: "" })}
              sx={{ mt: 2, fontSize: "0.85rem", textTransform: "lowercase" }}
            >
              {message.text}
            </Alert>
          )}
          <Stack direction="row" spacing={1} mt={2}>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<Check />}
              sx={{ textTransform: "none", fontSize: "0.9rem", py: 1 }}
              onClick={handleConfirm}
              loading={loading}
              loadingPosition="start"
            >
              Confirmar
            </LoadingButton>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleClose}
              sx={{ textTransform: "none", fontSize: "0.9rem", py: 1 }}
              disabled={loading}
            >
              Cancelar
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
